import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import CookieConsent from "react-cookie-consent"
import { StaticQuery, graphql, withPrefix } from 'gatsby'
import Footer from "../components/footer"
import Header from "../components/header_new_brand"

import GAPageScroll from './gaPageScroll'





const Layout = ({ children, theme, style ,metaName, metaDescription, metaImage}) => (
  <div>
    <StaticQuery
      query={graphql`
        query MetaQuery {
          allStrapiMicrosites(filter: {id: {eq: "Microsites_61deccc5ce7dda172be0cc02"}}) {
         edges {
           node {
             id
             site_intro
             site_name
             site_description
             sub_message

           }
         }
       }
     }
      `}
      render={data => (
        <>
          <Helmet
            title={data.allStrapiMicrosites.edges[0].node.site_name +' - ' + metaName}
            meta={[
              { name: 'description', content: metaDescription },
              {property:'og:image', content: "https://publications.aecom.com" + metaImage},
              {property:'og:title', content: data.allStrapiMicrosites.edges[0].node.site_name +' - ' + metaName},
              {property:'og:description', content: metaDescription},
              {property:'og:site_name', content: data.allStrapiMicrosites.edges[0].node.site_name},
              {name:"twitter:card", content:"summary_large_image"}
            ]}
          >
            <html lang="en" class="has-flex has-flex-wrap"/>
          </Helmet>
      <div className="layout-inner">
      <Header />


        <main id="page-wrap">
    {children}
    </main>
<Footer/>

</div>
        </>
      )}
    />
    <GAPageScroll/>
  </div>
)



Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
